import React, { useState } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";

const DEFAULT_PRODUCT = '/defaults/default-product.svg';
const handleImgError = (e) => { e.target.onerror = null; e.target.src = DEFAULT_PRODUCT; };

function Promotion({ sliderPromotion = [] }) {
  const [activeTab, setActiveTab] = useState('all');

  const filteredPromotions = activeTab === 'all'
    ? sliderPromotion
    : sliderPromotion.filter(p => p.status === activeTab);

  return (
    <div className="et-boc">
      <Header />
      <div id="et-main-area">
        <div id="main-content">
          <div className="et-l et-l--body">
            <div className="et_builder_inner_content et_pb_gutters3">
              <div className="et_pb_section et_pb_section_0_tb_body et_section_regular">
                <div className="et_pb_row et_pb_row_0_tb_body">
                  <div className="et_pb_column et_pb_column_4_4 et_pb_column_0_tb_body et_pb_css_mix_blend_mode_passthrough et-last-child">
                    <div className="et_pb_module et_pb_text et_pb_text_0_tb_body et_pb_text_align_center et_pb_bg_layout_light">
                      <div className="et_pb_text_inner">
                        <h1>Promotions</h1>
                      </div>
                    </div>
                    <div className="promotions-tabs" style={{ textAlign: 'center', marginBottom: '30px' }}>
                      <button
                        className={`tab-btn ${activeTab === 'all' ? 'active' : ''}`}
                        onClick={() => setActiveTab('all')}
                        style={{
                          padding: '10px 20px',
                          margin: '0 5px',
                          border: 'none',
                          borderRadius: '5px',
                          cursor: 'pointer',
                          backgroundColor: activeTab === 'all' ? '#f5a623' : '#333',
                          color: '#fff',
                          fontWeight: 'bold'
                        }}
                      >
                        All
                      </button>
                      <button
                        className={`tab-btn ${activeTab === 'active' ? 'active' : ''}`}
                        onClick={() => setActiveTab('active')}
                        style={{
                          padding: '10px 20px',
                          margin: '0 5px',
                          border: 'none',
                          borderRadius: '5px',
                          cursor: 'pointer',
                          backgroundColor: activeTab === 'active' ? '#f5a623' : '#333',
                          color: '#fff',
                          fontWeight: 'bold'
                        }}
                      >
                        Active
                      </button>
                    </div>
                    <div className="promotions-grid" style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'center' }}>
                      {filteredPromotions.length > 0 ? filteredPromotions.map((promo, i) => {
                        const imgPath = promo.thumbnail || promo.thubmnail;
                        return (
                          <div key={i} className="promotion-card" style={{
                            borderRadius: '10px',
                            overflow: 'hidden',
                            backgroundColor: '#1a1a2e',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
                          }}>
                            {imgPath ? (
                              <img
                                src={`${process.env.REACT_APP_API_URL}/storage/${imgPath}`}
                                alt={promo.name || ''}
                                style={{ width: '100%', height: '200px', objectFit: 'cover' }}
                                onError={handleImgError}
                              />
                            ) : (
                              <img
                                src={DEFAULT_PRODUCT}
                                alt={promo.name || 'Promotion'}
                                style={{ width: '100%', height: '200px', objectFit: 'cover' }}
                              />
                            )}
                            <div style={{ padding: '15px' }}>
                              {promo.name && <h3 style={{ color: '#f5a623', marginBottom: '10px' }}>{promo.name}</h3>}
                              {promo.link && <p style={{ color: '#ccc' }} dangerouslySetInnerHTML={{ __html: promo.link }} />}
                            </div>
                          </div>
                        );
                      }) : (
                        <p style={{ color: '#ccc', textAlign: 'center' }}>No promotions available.</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Promotion;
